import { Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "./auth-service.service";

@Injectable()
export class AdminAuthGuardService {
  constructor(
    public router: Router,
    private zone: NgZone,
    private authService: AuthService
  ) {}

  canActivate(): boolean {
    if (!this.authService.is_admin() && !this.authService.is_superadmin()) {
      this.zone.run(() => {
        this.router.navigate(["/dashboard/add"]);
      });
      return false;
    }
    return true;
  }
}
